const BASE_URL = 'https://khata.moxpal.com/api/v2/index.php'

function getToken() {
  return localStorage.getItem('token') || localStorage.getItem('login_token')
}

export async function request(endpoint, options = {}) {
  const token = getToken()

  const headers = {
    Authorization: `Bearer ${token}`,
    ...(options.headers || {}),
  };

  // Only set Content-Type to application/json if body is not FormData
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method: options.method || 'GET',
    headers,
    body: options.body || null,
  })

  const raw = await response.text()

  let data
  try {
    data = JSON.parse(raw)
  } catch (err) {
    console.error('Invalid JSON response:', raw)
    throw new Error('API returned invalid response')
  }

  const isExplicitSessionExpiry =
    data?.error?.code === 'SESSION_EXPIRED' ||
    data?.error?.code === 'INVALID_TOKEN';

  if (isExplicitSessionExpiry) {
    localStorage.removeItem('token')
    localStorage.removeItem('login_token')
    localStorage.removeItem('mobile')
    localStorage.removeItem('user_id')
    window.location.href = '/login'
    return
  }

  if (!response.ok || data?.success === false) {
    console.error('API Error Details:', { status: response.status, data });
    throw new Error(
      data?.error?.message || data?.message || 'Something went wrong'
    );
  }

  return data
}

/* =========================
   DASHBOARD
 ========================= */

export async function getDashboardSummary() {
  return request('/dashboard')
}

export async function getCustomerDetails(customerId) {
  return request(`/khata/customers/${customerId}`)
}

export async function getCustomerLedger(customerId) {
  return request(`/khata/customer-ledger?id=${customerId}`)
}

export async function addEntry(formData) {
  return request('/khata/entry', {
    method: 'POST',
    body: formData,
  })
}

export async function deleteEntry(entryId) {
  return request(`/khata/entry/${entryId}`, {
    method: 'DELETE'
  })
}

export async function updateEntry(entryId, formData) {
  return request(`/khata/entry/${entryId}`, {
    method: 'POST',
    body: formData,
  })
}

export async function getEntryDetails(entryId) {
  return request(`/khata/entry/${entryId}`)
}

/* =========================
   CUSTOMERS
 ========================= */

export async function searchCustomers(query = '') {
  const q = query ? `?search=${encodeURIComponent(query)}` : ''
  return request(`/khata/customers${q}`)
}

export async function addCustomer(payload) {
  return request('/khata/customers', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function addSupplier(payload) {
  return request('/khata/customers', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function updateCustomer(customerId, payload) {
  return request(`/khata/customers/${customerId}`, {
    method: 'POST', // Based on typical pattern or POST with _method=PUT
    body: JSON.stringify(payload),
  })
}

export async function deleteCustomer(customerId) {
  return request(`/khata/customers/${customerId}`, {
    method: 'DELETE',
  })
}

export async function toggleCustomerWhatsapp(customerId, enabled) {
  return request(`/whatsapp/toggle-customer?customer_id=${customerId}`, {
    method: 'POST',
    body: JSON.stringify({ enabled: enabled ? 1 : 0 }),
  })
}

export async function updateWhatsappLanguage(lang) {
  return request('/whatsapp/language', {
    method: 'POST',
    body: JSON.stringify({ lang }),
  })
}

/* =========================
   ENTRIES
 ========================= */

/* =========================
   AUTH
 ========================= */

export function logoutUser() {
  localStorage.removeItem('token')
  localStorage.removeItem('login_token')
  localStorage.removeItem('mobile')
  localStorage.removeItem('user_id')
  window.location.href = '/login'
}

/* =========================
   business profile
 ========================= */

export async function getBusinessProfile() {
  return request('/business-profile')
}

/* =========================
   CASHBOOK
 ========================= */

export async function getCashbookData() {
  return request('/cashbook')
}

export async function getCashbookEntryDetails(id) {
  return request(`/cashbook/${id}`)
}

export async function addCashbookEntry(formData) {
  // Use /cashbook as seen in mobile service
  return request('/cashbook', {
    method: 'POST',
    body: formData, // FormData handles entry_type, amount, payment_mode, note, etc.
  })
}

export async function deleteCashbookEntry(id) {
  return request(`/cashbook/${id}`, {
    method: 'DELETE'
  })
}

export async function updateCashbookEntry(id, formData) {
  // Mobile service uses POST with _method=PUT
  return request(`/cashbook/${id}`, {
    method: 'POST',
    body: formData,
  })
}

export async function getCashbookReport(fromDate, toDate) {
  const url = `/cashbook/report?from=${fromDate}&to=${toDate}&timestamp=${Date.now()}`;
  console.log("Fetching Report from:", url);
  return request(url);
}

export const getCashbookReportNamed = getCashbookReport; // For backward compatibility if needed

export const dashboardApi = {
  getDashboardSummary,
  getCustomerDetails,
  getCustomerLedger,
  addEntry,
  deleteEntry,
  updateEntry,
  getEntryDetails,
  searchCustomers,
  addCustomer,
  addSupplier,
  updateCustomer,
  deleteCustomer,
  toggleCustomerWhatsapp,
  updateWhatsappLanguage,
  getBusinessProfile,
  getCashbookData,
  getCashbookEntryDetails,
  addCashbookEntry,
  deleteCashbookEntry,
  updateCashbookEntry,
  getCashbookReport
};